import { useQuery } from '@tanstack/react-query';
import { getAppHtmlPolicy } from '@api/apps';

/** The server's HTML policy; it only changes with a deploy, so it is read once. */
export const useHtmlPolicy = (enabled = true) =>
  useQuery({
    queryKey: ['apps', 'htmlPolicy'],
    queryFn: getAppHtmlPolicy,
    staleTime: Infinity,
    enabled,
  });
